import { render, staticRenderFns } from "./GenerateView.vue?vue&type=template&id=3bb5da52&scoped=true"
import script from "./GenerateView.vue?vue&type=script&lang=js"
export * from "./GenerateView.vue?vue&type=script&lang=js"
import style0 from "./GenerateView.vue?vue&type=style&index=0&id=3bb5da52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5da52",
  null
  
)

export default component.exports